import { BillingData } from 'gw-edge-client';
import { useCallback, useState } from 'react';
const useActivateMPS = (): {
    activateMps: (policyNumber: string, payerPhoneNumber: string, redirectUrl: string) => void;
    errorMessage: Error | undefined;
    resetError: () => void;
} => {
    const [errorMessage, setErrorMessage] = useState<Error | undefined>(undefined);
    const activateMps = (
        policyNumber: string,
        payerPhoneNumber: string,
        redirectUrl: string
    ): void => {
        BillingData.activateMps(policyNumber, payerPhoneNumber, redirectUrl)
            .then((response) => {
                if (response.redirectUrl) {
                    window.location.href = response.redirectUrl;
                }
            })
            .catch((e) => {
                setErrorMessage(e);
            });
    };

    const resetError = useCallback(() => {
        setErrorMessage(undefined);
    }, []);

    return { activateMps, errorMessage, resetError };
};

export default useActivateMPS;
